export default __webpack_public_path__ + "static/media/chrome3-preview.812fb8cb.png";